export default {
  path: 'products',
  name: 'publisher',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-products" */ './Products')
}
